module.exports = __webpack_public_path__ + "static/media/being_five.0777b2e4.png";